<template>
  <div
    class="data-board"
    :style="{
      border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9'
    }"
    ref="dataBoard"
  >
    <div class="databoard">
      <div class="databoard_header flex">
        <div class="title">
          <eui-icon class="data-icon" icon="eicon-sjjsc" color="#333" />
          <div class="text">数据驾驶舱</div>
        </div>
      </div>
      <div class="chart1">
        <div class="chart1-1">
          <div id="myChart00"></div>
        </div>
        <div class="chart1-2">
          <el-popover
            class="popover"
            placement="bottom"
            :offset="-20"
            trigger="click"
            ref="popover"
          >
            <div>
              <el-date-picker
                :clearable="false"
                @change="dateSet"
                class="datepicker"
                v-model="queryData.date"
                type="monthrange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="date flex" slot="reference">
              <!-- <img src="@/assets/img/workbench/date.png" height="16px" alt="" /> -->
              <p>
                {{ getFormatDate() }}
                <i class="el-icon-arrow-down"></i>
              </p>
            </div>
          </el-popover>
          <div id="myChart01"></div>
        </div>
      </div>

      <div class="charts_list">
        <div class="chart2">
          <!-- <div v-show="lbbmList.length != 0"> -->
          <div id="myChart02"></div>
            <div class="flex">
                <eui-btn font-size="12px" type="text" class="more" @click="toMore" v-if="dataType === 2">更多</eui-btn>
                <div class="chart2_btn flex">
                    <p :class="dataType === 1 ? 'active' : ''" @click="changeDataType(1)">部门</p>
                    <p :class="dataType === 2 ? 'active' : ''" @click="changeDataType(2)">采购员</p>
                </div>
            </div>

            <!-- </div> -->
          <!-- <div class="empty" v-show="lbbmList.length == 0">
            <img src="@/assets/img/workbench/empty.png" height="160px" alt="" />
            <p class="text">暂无数据</p>
          </div> -->
        </div>
        <div class="chart3">
          <!-- <div v-show="depList.length != 0"> -->
          <div id="myChart03"></div>
          <!--  </div> -->
          <!-- <div class="empty" v-show="depList.length == 0">
            <img src="@/assets/img/workbench/empty.png" height="160px" alt="" />
            <p class="text">暂无数据</p>
          </div> -->
        </div>
        <div class="chart4">
          <!-- <el-popover
            class="popover"
            placement="bottom"
            :offset="-20"
            trigger="click"
            ref="popover"
          >
            <div>
              <el-date-picker
                :clearable="false"
                @change="dateSet"
                class="datepicker"
                v-model="queryData.date"
                type="monthrange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="date flex" slot="reference">
              <p>
                {{ getFormatDate() }}
                <i class="el-icon-arrow-down"></i>
              </p>
            </div>
          </el-popover> -->
          <!-- <div v-show="chart4List.length != 0"> -->
          <div id="myChart04"></div>
          <!-- </div> -->
          <!-- <div class="empty" v-show="chart4List.length == 0">
            <img src="@/assets/img/workbench/empty.png" height="160px" alt="" />
            <p class="text">暂无数据</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateformate, getYearAndMonth } from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/dataCenter';
import bus from '@/components/common/bus';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isLayoutSet: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      minDate: null,
      maxDate: null,

      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: time => {
          const choiceDateTime = new Date(this.selectDate).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 11
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 11
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后12个月时间可选,后12个月最大为当前日期
          if (this.selectDate) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      queryData: {
        date: [
          new Date().setMonth(new Date().getMonth() - 11),
          new Date().getTime()
        ]
      },
      purchaseData: [],
      purchaseColumns: [],
      dataType: 1,
      chart2TableData: [],
      chart3Data: [],
      chart4Columns: [],
      chart4Data: [],
      dateList: [],

      // depList
      depList: [],
      lbbmList: [],
      chart4List: [],

      myChart00: null,
      myChart01: null,
      myChart02: null,
      myChart03: null,
      myChart04: null,
      //采购占比chart图
      buyProportion: {
        title: {
          text: '采购占比',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [2, 0, 20, 0]
        },
        tooltip: {},
        legend: {
          top: 'bottom',
          icon: 'circle',
          padding: [0, 0, 20, 0],
          formatter(name) {
            // return name + '\n' + 10;
            return name.length > 4 ? name.slice(0, 4) + '...' : name;
          }
        },
        series: [
          {
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['40%', '50%'],
            data: [],
            itemStyle: {
              normal: {
                color: function (params) {
                  const colorList = [
                    '#6AA1FF',
                    '#5EDFD6',
                    '#C9E968',
                    '#FADC6D',
                    '#F98981',
                    '#E865DF',
                    '#625FFA',
                    '#5F81FA',
                    '#60CEF0',
                    '#4CD263',
                    '#FCF26B',
                    '#FAAC7B',
                    '#F979B7',
                    '#A871E3'
                  ];
                  if (params.name === '其他') {
                    colorList.splice(params.dataIndex, 0, '#E3E7FF');
                  }
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      },
    };
  },
  actions: {},

  head() {
    return {};
  },
  computed: {},
  mounted() {
    this.initData();
    this.getQueryOrderDataByMonthCurrent();
    this.getQuerySupplierOrderMonthOnMonthRatio();

    const mainChart = this.$refs.dataBoard;
    const that = this;
    const elementResizeDetectorMaker = require('element-resize-detector');
    let erd = elementResizeDetectorMaker();
    erd.listenTo(mainChart, ele => {
      setTimeout(() => {
        that.myChart00 && that.myChart00.resize();
        that.myChart01 && that.myChart01.resize();
        that.myChart02 && that.myChart02.resize();
        that.myChart03 && that.myChart03.resize();
        that.myChart04 && that.myChart04.resize();
      }, 0);
    });
  },
  methods: {
    toMore() {
      this.$router.push({path: "/procurementWorkload"})
    },
    //采购占比切换 1部门和 2采购员
    changeDataType(dataType) {
      this.dataType = dataType;
      this.depList = [];
      if (dataType === 1) {
        this.queryOrderBySupplierAndDepartment();
      } else {
        this.queryOrderByMember();
      }
    },
    getDiffMonth(dateOne, dateTwo) {
      dateOne = dateOne.split('-');
      dateOne = parseInt(dateOne[0]) * 12 + parseInt(dateOne[1]);
      dateTwo = dateTwo.split('-');
      dateTwo = parseInt(dateTwo[0]) * 12 + parseInt(dateTwo[1]);
      let diffMonth = Math.abs(dateOne - dateTwo);
      // console.log(diffMonth);
      return diffMonth;
    },
    async getQueryOrderDataByMonthCurrent() {
      // 参数
      let dateNum = new Date().getDate();
      const params = {
        startTime: dateformate(new Date().getTime(), 'yyyy-MM-1 00:00:00'),
        endTime: dateformate(
          new Date().getTime(),
          `yyyy-MM-${dateNum} 00:00:00`
        )
      };
      // let params =
      const result = await Api.queryOrderDataByMonth(params);
      const { purchaseData = [], supplierData = [] } = result.data;
      let purchase = 0;
      let supplier = 0;
      if (purchaseData.length !== 0) {
        purchase = (purchaseData[0].orderAmount / 10000).toFixed(2);
      }
      if (supplierData.length !== 0) {
        supplier = (supplierData[0].orderAmount / 10000).toFixed(2);
      }

      this.$nextTick(() => {
        this.echartsInit0(purchase, supplier);
      });
    },
    async getQueryOrderDataByMonth() {
      let params = this.handleParams();

      const result = await Api.queryOrderDataByMonth(params);
      if (result.code === '200') {
        const { purchaseData = [], supplierData = [] } = result.data;
        /* let pur = [];
        let sup = [];
        let monthList = []; */
        const monthList = purchaseData.map(item => item.months);
        const pur = purchaseData.map(item => item.orderAmount);
        const sup = supplierData.map(item => item.orderAmount);
        /* if (supplierData.length > purchaseData.length) {
          monthList = supplierData.map(item => item.months);
          for (let i = 0; i < supplierData.length; i++) {
            let item = supplierData[i];
            //if (item.months === purchaseData[i]?.months) {
            let purOrderAmount = purchaseData[i]?.orderAmount || 0;
            pur.push(purOrderAmount);
            //}

            let supOrderAmount = supplierData[i]?.orderAmount || 0;
            sup.push(supOrderAmount);
          }
        }
        if (supplierData.length < purchaseData.length) {
          monthList = purchaseData.map(item => item.months);
          for (let i = 0; i < purchaseData.length; i++) {
            let item = purchaseData[i];
            console.log(supplierData[i], 'supplierData[i]');
            //if (item.months === supplierData[i]?.months) {
            let supOrderAmount = supplierData[i]?.orderAmount || 0;
            sup.push(supOrderAmount);
            //}
            let purOrderAmount = purchaseData[i]?.orderAmount || 0;
            pur.push(purOrderAmount);
          }
        }
        if (supplierData.length === purchaseData.length) {
          monthList = purchaseData.map(item => item.months);
          //for (let i = 0; i < purchaseData.length; i++) {
          let purOrderAmount = purchaseData[i]?.orderAmount || 0;
          pur.push(purOrderAmount);
          let supOrderAmount = supplierData[i]?.orderAmount || 0;
          sup.push(supOrderAmount);
          //}
        } */
        const mixinList = [...pur, ...sup];
        const maxData = Math.max(...mixinList);
        let unit = '元'; // 单位
        const purArr = [];
        const supArr = [];

        /* if (maxData < 100) {
          unit = '元';
        } else if (10000000 >= maxData && maxData >= 100) {
          unit = '万元';
          pur.forEach(item => {
            purArr.push((item / 10000).toFixed(2));
          });
          sup.forEach(item => {
            supArr.push((item / 10000).toFixed(2));
          });
        } else if (maxData > 10000000) {
          unit = '亿元';
          pur.forEach(item => {
            purArr.push((item / 100000000).toFixed(2));
          });
          sup.forEach(item => {
            supArr.push((item / 100000000).toFixed(2));
          });
        } */
        // console.log(purArr, supArr, monthList, unit, '胜多负少的');
        this.$nextTick(() => {
          // this.echartsInit1(purArr, supArr, monthList, unit);
          this.echartsInit1(pur, sup, monthList);
        });
      }
    },
    // -----
    tableFiexed(name) {
      if (name == '年月') {
        return 'left';
      } else if (name == '合计') {
        return 'right';
      }
    },
    getFormatDate() {
      return (
        dateformate(this.queryData.date[0], 'yyyy年MM月') +
        '-' +
        dateformate(this.queryData.date[1], 'yyyy年MM月')
      );
    },
    dateSet() {
      this.$refs.popover.doClose();
      this.initData();
    },
    initData() {
      this.queryOrderBySupplierAndDepartment();
      this.queryOrderLbbmForSupplier();
      this.getQueryOrderDataByMonth();
      // this.queryOrderType();
    },
    handleParams() {
      let year = dateformate(this.queryData.date[1], 'yyyy');
      let month = dateformate(this.queryData.date[1], 'M');
      let dateNum = new Date(year, month, 0).getDate();
      let list = getYearAndMonth(
        dateformate(this.queryData.date[0], 'yyyy-MM'),
        dateformate(this.queryData.date[1], 'yyyy-MM')
      );
      list.unshift(dateformate(this.queryData.date[0], 'yyyy-MM'));
      let arr = [];
      list.forEach(item => {
        let year = item.split('-')[0];
        let month = parseInt(item.split('-')[1]);
        item = year + '-' + month;
        arr.push(item);
      });
      this.dateList = arr;
      return {
        startTime: dateformate(this.queryData.date[0], 'yyyy-MM-1 00:00:00'),
        endTime: dateformate(
          this.queryData.date[1],
          `yyyy-MM-${dateNum} 00:00:00`
        )
      };
    },

    async getQuerySupplierOrderMonthOnMonthRatio() {
      let res = await Api.querySupplierOrderMonthOnMonthRatio();
      if (res.success) {
        let { data = [] } = res;
        data = data.reverse();
        const barList = data.map(item => item.totalAmount);
        const lineList = data.map(item => item.rate);
        const monthList = data.map(item => item.dateTime);
        this.chart4List = [...data];
        this.$nextTick(() => {
          this.echartsInit4(barList, lineList, monthList);
        });
      }
    },
    //采购占比部门查询接口
    async queryOrderBySupplierAndDepartment() {
      let params = this.handleParams();
      let res = await Api.queryOrderBySupplierAndDepartment(params);
      if (res.success) {
        const { purchaseZoneDepartmentList = [] } = res.data;
        const depList = purchaseZoneDepartmentList.map(item => ({
          value: item.orderAmount,
          name: item.departmentName
        }));
        this.depList = [...depList];
        if (depList.length === 0) {
          this.depList = [{ value: 0, name: '其他' }];
        }
        setTimeout(() => {
          this.echartsInit2(this.depList);
        }, 10);
      }
    },
    //采购占比采购员查询接口
    async queryOrderByMember() {
      let res = await Api.queryOrderByMember();
      if (res.code === '200') {
        res.data.forEach(item => {
          this.depList.push({
            value: item.orderAmount,
            name: item.memberRealName
          })
        })
        setTimeout(() => {
          this.echartsInit2(this.depList);
        }, 10);
      }
    },

    /*
      {
        "departmentName": "其他",
        "orderAmount": 0,
        "value": 0,
        "name": "其他"
      }
    */

    async queryOrderLbbmForSupplier() {
      let params = this.handleParams();
      let res = await Api.queryOrderLbbmForSupplier(params);
      if (res.success) {
        let list = res.data ? res.data : [];
        let obj1 = {};
        let chartData = [];
        if (list.length > 0) {
          chartData = list.map(item => ({
            value: item.orderAmount,
            name: item.lbmc
          }));
        } else {
          chartData = [{ value: 0, name: '其他' }];
        }

        setTimeout(() => {
          this.echartsInit3(chartData);
        }, 0);
      }
    },

    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    echartsInit0(purchase, supplier) {
      this.myChart00 = this.$echarts.init(document.getElementById('myChart00'));
      this.myChart00.setOption({
        legend: {
          top: 'bottom'
        },
        title: {
          text: '企业核心数据月度复盘',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [20, 0, 0, 20]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        grid: {
          top: '26%', //grid组件距上下左右的距离
          left: '3%',
          right: '3%',
          bottom: '10%',
          containLabel: true //grid区域是否包含坐标轴的刻度标签。
        },

        xAxis: {
          type: 'category',
          data: ['销售收入', '采购支出'],
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: '单位: 万元'
        },
        // purchase, supplier
        series: [
          {
            data: [
              {
                value: supplier,
                itemStyle: {
                  color: '#6AA1FF'
                }
              },
              {
                value: purchase,
                itemStyle: {
                  color: '#FADC6D'
                }
              }
            ],
            type: 'bar',
            barWidth: 16
          }
        ]
      });
      this.resize(this.myChart00);
    },
    echartsInit1(purList, supList, monthList) {
      this.myChart01 = this.$echarts.init(document.getElementById('myChart01'));
      this.myChart01.setOption({
        color: ['#6AA1FF', '#FADC6D'],
        title: {
          text: '历月采销情况',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [20, 0, 0, 20]
        },
        legend: {
          top: 'bottom',
          icon: 'circle',
          padding: [0, 0, 20, 0]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
          /* formatter: function(array) {
            // console.log(array, 'array');
            const purItem = array[0];
            const purMarker = purItem.marker;
            const purSeriesName = purItem?.supSeriesName || '';
            const purValue = purItem?.value || '';
            const name = purItem.name;

            const supItem = array[1];
            const supMarker = supItem?.marker || '';
            const supSeriesName = supItem?.supSeriesName || '';
            const supValue = supItem?.value || '';
            return (
              name +
              '<br />' +
              purMarker +
              purSeriesName +
              purValue +
              '  ' +
              unit +
              '元' +
              '<br />' +
              supMarker +
              supSeriesName +
              supValue +
              '  ' +
              unit +
              '元'
            );
          }, */
        },
        /* tooltip: {
          formatter: function(array) {
            console.log(array, 'array');
            // return array.marker + array.name + '   ' + array.value + '%';
            return array.marker + array.name + '   ' + array.value;
          },
        }, */
        grid: {
          top: '24%', //grid组件距上下左右的距离
          left: '3%',
          right: '3%',
          bottom: '15%',
          containLabel: true //grid区域是否包含坐标轴的刻度标签。
        },
        xAxis: {
          type: 'category',
          data: monthList,
          // data: ['销售收入', '采购支出'],
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function(value, index) {
              if (value < 100) {
              } else if (10000000 >= value && value >= 100) {
                value = (value / 10000).toFixed(2) + 'w';
              } else if (value > 10000000) {
                value = (value / 100000000).toFixed(2) + '亿';
              }
              /* if (value > 10000) {
                value = (Math.round((value / 10000) * 100) / 100).toFixed(0) + 'w';
              } else {
                value = value.toFixed(1);
              } */
              return value;
            }
          }
        },
        series: [
          {
            name: '销售收入',
            type: 'bar',
            /* label: {
                show: true,
              }, */
            emphasis: {
              focus: 'series'
            },
            barWidth: 16,
            data: supList
            /* data: [320, 302, 301, 334, 390, 330, 320], */
            /* data: [
                {
                  value: 320,
                  itemStyle: {
                    color: '#6AA1FF',
                  },
                },
                {
                  value: 300,
                  itemStyle: {
                    color: '#6AA1FF',
                  },
                },
              ], */
          },
          {
            name: '采购支出',
            type: 'bar',
            /* label: {
                show: true,
              }, */
            emphasis: {
              focus: 'series'
            },
            barWidth: 16,
            data: purList
            // data: [120, 132, 101, 134, 90, 230, 210],
            /* data: [
                {
                  value: 200,
                  itemStyle: {
                    color: '#FADC6D',
                  },
                },
                {
                  value: 200,
                  itemStyle: {
                    color: '#FADC6D',
                  },
                },
              ], */
          }
        ]
      });
      this.resize(this.myChart01);
    },
    echartsInit2(data) {
      this.myChart02 = this.$echarts.init(document.getElementById('myChart02'));
      this.buyProportion.series[0].data = data;
      this.myChart02.setOption(this.buyProportion);
      this.resize(this.myChart02);
    },
    echartsInit3(data) {
      this.myChart03 = this.$echarts.init(document.getElementById('myChart03'));
      this.myChart03.setOption({
        title: {
          text: '销售品类构成',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [2, 0, 20, 0]
        },
        tooltip: {
          formatter: function(array) {
            // return array.marker + array.name + '   ' + array.value + '%';
            return array.marker + array.name + '   ' + array.value;
          }
        },
        legend: {
          top: 'bottom',
          icon: 'circle',
          padding: [2, 0, 20, 0],
          formatter(name) {
            // return name + '\n' + 10;
            return name.length > 4 ? name.slice(0, 4) : name;
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['40%', '50%'],
            data: data,
            itemStyle: {
              normal: {
                color: function(params) {
                  const colorList = [
                    '#6AA1FF',
                    '#5EDFD6',
                    '#C9E968',
                    '#FADC6D',
                    '#F98981',
                    '#E865DF',
                    '#625FFA',
                    '#5F81FA',
                    '#60CEF0',
                    '#4CD263',
                    '#FCF26B',
                    '#FAAC7B',
                    '#F979B7',
                    '#A871E3'
                  ];
                  if (params.name === '其他') {
                    colorList.splice(params.dataIndex, 0, '#E3E7FF');
                  }
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      });
      this.resize(this.myChart03);
    },

    echartsInit4(barList, lineList, monthList) {
      // console.log(barList, lineList, '是是是');
      let yMax1 = Math.max(...barList);
      let yMin1 = Math.min(...barList);

      let yMax2 = Math.max(...lineList);
      let yMin2 = Math.min(...lineList);

      const ratio = (yMax1 - yMin1) / (yMax2 - yMin2);

      let interval1 = 1;
      let interval2 = 1;
      if (yMax1 - yMin1 > 0) {
        interval1 = (yMax1 - yMin1) / 5;
      }
      if (yMax2 - yMin2 > 0) {
        interval2 = (yMax2 - yMin2) / 5;
      }

      this.myChart04 = this.$echarts.init(document.getElementById('myChart04'));
      this.myChart04.setOption({
        legend: {
          top: 'bottom',
          padding: [0, 0, 20, 0]
        },
        title: {
          text: '收入及增速同比变化',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [2, 0, 20, 0]
        },
        xAxis: {
          data: monthList
          // boundaryGap: false,
          /* axisLabel: {
            rotate: 45,
          }, */
        },
        //直角坐标系内绘图网格
        grid: {
          left: '10%',
          right: '10%',
          containLabel: true //grid区域是否包含坐标轴的刻度标签。
        },

        yAxis: [
          {
            type: 'value',
            name: '收入(元)',
            minInterval: 1,
            axisLabel: {
              formatter: function(value, index) {
                /* if (value > 10000) {
                  value = (Math.round((value / 10000) * 100) / 100).toFixed(0) + 'w';
                } */
                return value;
              }
            },
            /* min: yMin1,
            max: yMax1,
            splitNumber: 5,
            interval: interval1,*/

            yAxisIndex: 0,
            splitLine: {
              show: true
            }
            //boundaryGap: false,
          },
          {
            type: 'value',
            name: '增速(%)',
            minInterval: 1,
            axisLabel: {
              formatter: function(value, index) {
                return value.toFixed(2);
              }
            },
            /*  min: yMin2,
            max: yMax2,
            splitNumber: 5,
            interval: interval2,*/

            yAxisIndex: 1,
            splitLine: {
              show: false,
              lineStyle: {
                color: '#888888'
              }
            }
            //boundaryGap: false,
          }
        ],
        series: [
          {
            name: '收入',
            type: 'bar',
            data: barList,
            yAxisIndex: 0,
            barWidth: 18, //柱图宽度
            itemStyle: {
              /* color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#32DAFF' },
                { offset: 1, color: '#28B2FF' },
              ]), */
              color: '#6AA1FF'
            }
          },
          {
            name: '增速(右轴)',
            itemStyle: {
              color: '#FAAC7B'
            },
            type: 'line',
            smooth: true,
            data: lineList,
            yAxisIndex: 1
          }
        ]
      });
      this.resize(this.myChart04);
    },

    resize(chart) {
      window.addEventListener('resize', function() {
        chart.resize();
      });
    }
  }
  /* destroyed() {
    window.removeEventListener();
  }, */
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.data-board {
  width: 100%;
  margin-top: 20px;

  .databoard {
    .databoard_header {
      padding: 0 20px;
      height: 44px;
      background: #f5f5f5;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      .date {
        cursor: pointer;
        align-items: center;
        img {
          margin-right: 5px;
        }
        i {
          margin-left: 4px;
        }
      }
      .title {
        font-size: 14px;
        display: flex;
        align-items: center;
        background: #f5f5f5;
        color: #333;
        .text {
          margin-left: 10px;
        }
      }
    }
    .table {
      padding: 20px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
#myChart00 {
  width: 100%;
  height: 316px;
}
#myChart01 {
  width: 100%;
  height: 337px;
}
#myChart02 {
  width: 100%;
  height: 337px;
}
#myChart03 {
  width: 100%;
  height: 337px;
}
#myChart04 {
  width: 100%;
  height: 337px;
}
.chart1 {
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  .chart1-1 {
    width: 33.333%;
    border-right: 1px solid #d9d9d9;
  }
  .chart1-2 {
    position: relative;
    flex: 2;
    .popover {
      position: absolute;
      right: 22px;
      top: 20px;
      z-index: 1;
      cursor: pointer;
      ::v-deep .el-popover__reference {
        color: #333;
        font-size: 12px;
      }
    }
  }
}
.charts_list {
  display: flex;
  // justify-content: space-between;
  height: 377px;
  & > div:not(:last-child) {
    border-right: 1px solid #d9d9d9;
  }
  & > div {
    padding: 20px;
    width: 33.33%;
  }

  .chart2 {
    background: #ffffff;
    //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    height: 100%;
    position: relative;

      .more {
          position: absolute;
          top: 22px;
          right: 128px;
          border-right: 1px solid #D9D9D9;
          padding-right: 10px;
          height: 22px;
          line-height: 22px;
      }
    .chart2_btn {
      position: absolute;
      right: 20px;
      top: 20px;
      background: #f5f5f5;
      border-radius: 1px;
      width: 96px;
      height: 24px;
      padding: 3px;
      z-index: 999;
      p {
        flex: 0 0 50%;
        text-align: center;
        line-height: 18px;
        color: #666666;
        font-size: 12px;
        cursor: pointer;
      }
      .active {
        color: $main-col;
        background: #fff;
      }
    }
    .chart2_table {
      display: flex;
      flex-wrap: wrap;

      max-height: 165px;
      overflow-y: auto;
      .chart2_table_item {
        width: 33.333333%;

        border-right: 1px solid #dcdcdc;
        border-left: 1px solid #dcdcdc;
        border-top: 1px solid #dcdcdc;
        p {
          height: 40px;
          line-height: 40px;
          color: #333333;
          font-size: 14px;
          text-align: center;
          border-bottom: 1px solid #dcdcdc;
        }
        .name {
          background: #f5f5f5;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .item3 {
        border-right: none;
      }
    }
  }
  .chart3 {
    background: #ffffff;
    //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    height: 100%;
  }
  .chart4 {
    position: relative;
    background: #ffffff;
    height: 100%;
    .popover {
      position: absolute;
      right: 22px;
      top: 20px;
      z-index: 1;
      ::v-deep .el-popover__reference {
        color: #333;
        font-size: 12px;
      }
    }
  }
}
.datepicker {
  ::v-deep .el-range-separator {
    width: 30px !important;
  }
}

/*修改滚动条样式*/
.scrollbar_content_none {
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar_content_none::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/*修改滚动条样式*/
.scrollbar_content {
  overflow-y: auto;
  -ms-overflow-style: none;
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    height: 8px;
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 2px;
  }
  ::v-deep .el-table__fixed-right {
    height: 100% !important;
  }
  ::v-deep .el-table__fixed {
    height: 100% !important;
  }
}

.empty {
  height: 462px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .text {
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
  }
}
</style>
